export default __webpack_public_path__ + "static/media/other_color.4286c2c8.svg";